function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M30.999 61.998c-17.121 0-31-13.879-31-31 0-17.121 13.879-31 31-31 17.121 0 30.999 13.879 30.999 31 0 17.121-13.878 31-30.999 31zm0-60.121c-16.083 0-29.121 13.038-29.121 29.121S14.916 60.12 30.999 60.12c16.082 0 29.121-13.039 29.121-29.122S47.081 1.877 30.999 1.877zm2.716 36.83a1.001 1.001 0 0 1-1.415-1.414L37.593 32H22.007a1 1 0 0 1 0-2h15.587L32.3 24.707a1 1 0 0 1 1.415-1.414l7 7a1 1 0 0 1 0 1.414l-7 7z"
});

var SvgCircleArrow = function SvgCircleArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCircleArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/circle-arrow.c5c801d4.svg";
export { ForwardRef as ReactComponent };